import React, { Component } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import { translate } from 'react-i18next'
import { Link } from 'react-router-dom'

import { Roles } from '../../config'
import { addCompany } from '../../actions'

import { Form, Input, Button, Select } from 'antd'
const FormItem = Form.Item
const Option = Select.Option

class AppSettingsCompanies extends Component {
  state = {
    userProjects: null // helper for Projects multiselect field
  }

  handleProjectsChange = values => {
    this.setState({ userProjects: [...values] })
  }

  handleSubmit = e => {
    e.preventDefault()
    const { form, addCompany } = this.props

    form.validateFields((err, values) => {
      if (!err) {
        addCompany(values.companyName)
      } else {
        console.log(err)
      }
    })
  }

  resetFormFields = () => {
    const { form } = this.props

    form.resetFields()
    this.setState({ userProjects: null })
  }

  render () {
    const { form: { getFieldDecorator }, projects, loading, user, companies, t } = this.props
    const { userProjects } = this.state

    const projectsThatIAmManagerIn = _.pickBy(user.projectsRoles, role => role <= Roles.PROJECT.MANAGER)

    const projectsOptions = []
    _.map(projectsThatIAmManagerIn, (role, projectId) =>
      projectsOptions.push(
        <Option key={projectId} value={projectId}>
          {projects[projectId].name}
        </Option>
      )
    )

    const rolesOptions = []
    _.map(Roles.PROJECT, (role, roleKey) =>
      rolesOptions.push(
        <Option key={role} value={role}>
          {t(`roles.${roleKey}`)}
        </Option>
      )
    )

    const roleFormItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 6 }
    }

    return (
      <div>
        {/* list of all Companies */}
        <div>
          <h2>Companies:</h2>
          {companies &&
            _.map(companies, (company, companyId) => (
              <p key={companyId}>
                <Link to={`/settings/company/${companyId}`}>{company.name}</Link>
              </p>
            ))}
        </div>

        {/* form - add new Company  */}
        {user.isSuperAdmin &&
          <div style={{ marginTop: 50 }}>
            <h2>Add new Company:</h2>
            <Form onSubmit={this.handleSubmit}>

              <FormItem label='Company'>
                {getFieldDecorator('companyName', {
                  rules: [{ required: true }]
                })(<Input placeholder='Name of the new company' />)}
              </FormItem>

              {userProjects &&
                userProjects.map(projectId => (
                  <FormItem label={projects[projectId].name} {...roleFormItemLayout} key={projectId}>
                    {getFieldDecorator(`projects.${projectId}`, {
                      // rules: [{ required: true, message: 'Project role is required' }],
                      initialValue: 30 // 'Client'
                    })(
                      <Select placeholder='Project role'>
                        {rolesOptions}
                      </Select>
                    )}
                  </FormItem>
                ))}

              <Button type='primary' htmlType='submit' loading={loading.addCompany}>Create company</Button>

            </Form>
          </div>}
      </div>
    )
  }
}

// =====================================
//  REDUX CONNECT
// -------------------------------------

const mapStateToProps = state => ({
  projects: state.projects,
  user: state.user,
  loading: state.loading,
  companies: state.companies
})

const mapDispatchToProps = {
  addCompany
}

export default connect(mapStateToProps, mapDispatchToProps)(
  Form.create()(translate('translations')(AppSettingsCompanies))
)



// WEBPACK FOOTER //
// ./src/components/AppSettings/AppSettingsCompanies.js